import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root', // Ensures it's available throughout the app// Provide DatePipe explicitly
})
export class DateUtilService {
  constructor(private datePipe: DatePipe) {}

  formatDate(date: any, format: string = 'yyyy-MM-dd'): string | null {
    if (!date) return null;

    // Try parsing the date
    const parsedDate = new Date(date);
    
    // Check if the parsed date is valid
    if (isNaN(parsedDate.getTime())) return null;

    return this.datePipe.transform(parsedDate, format);
  }

  parseFlexibleDate(raw: string): string | null {
    if (!raw) return null;
    raw = raw.trim();

    const monthNames: { [key: string]: string } = {
      january:'01',february:'02',march:'03',april:'04',may:'05',june:'06',
      july:'07',august:'08',september:'09',october:'10',november:'11',december:'12',
      jan:'01',feb:'02',mar:'03',apr:'04',jun:'06',jul:'07',aug:'08',
      sep:'09',oct:'10',nov:'11',dec:'12'
    };

    let day = '', month = '', year = '';

    const textMatch = raw.match(/^(\d{1,2})\s+([a-zA-Z]+)\s+(\d{2,4})$/);
    if (textMatch) {
      day = textMatch[1].padStart(2, '0');
      month = monthNames[textMatch[2].toLowerCase()] || '';
      year = textMatch[3].length === 2 ? '20' + textMatch[3] : textMatch[3];
    }

    const numMatch = raw.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{2,4})$/);
    if (!textMatch && numMatch) {
      day = numMatch[1].padStart(2, '0');
      month = numMatch[2].padStart(2, '0');
      year = numMatch[3].length === 2 ? '20' + numMatch[3] : numMatch[3];
    }

    const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!textMatch && !numMatch && isoMatch) {
      return raw;
    }

    if (day && month && year) {
      return `${year}-${month}-${day}`; // ISO format YYYY-MM-DD
    }
    return raw;
  }

  formatDateDisplay(dateStr: string): string {
    if (!dateStr) return '';
    const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
      const year = isoMatch[1];
      const month = isoMatch[2];
      const day = isoMatch[3];
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return `${day} ${monthNames[parseInt(month, 10) - 1]} ${year}`;
    }
    return dateStr;
  }
}
